import { render, staticRenderFns } from "./editLocation.vue?vue&type=template&id=c08fdc24&scoped=true"
import script from "./editLocation.vue?vue&type=script&lang=js"
export * from "./editLocation.vue?vue&type=script&lang=js"
import style0 from "./editLocation.vue?vue&type=style&index=0&id=c08fdc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08fdc24",
  null
  
)

export default component.exports